import angular from 'angular';
import EventEmitter from 'utility/event-emitter';
import { VideoFreezeAnalyzer } from 'providers/video/common/lib/video-freeze-analyzer';
import { RootScopeEvents } from 'common/services/root-scope-types';
import { AngularServices } from '../../../../modules/core';
import { VideoProviderEvents } from '../video-provider-events';
export class VideoFreezeDetector extends EventEmitter {
    /* @ngInject */
    constructor(VideoProviderFactory, $rootScope) {
        super();
        this.VideoProviderFactory = VideoProviderFactory;
        this.$rootScope = $rootScope;
        this.streamsMap = new Map();
    }
    init() {
        this.activeProvider.on(VideoProviderEvents.StreamCreated, (stream) => this.addStream(stream));
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.SESSION_DISCONNECTED, () => this.reset());
    }
    reset() {
        this.analyzersList.forEach((analyzer) => analyzer.stop());
        this.streamsMap.clear();
    }
    get stats() {
        const reducedDuration = this.analyzersList
            .map((analyzer) => analyzer.stats)
            .map((stats) => stats.frozenVideoDuration)
            .reduce((acc, value) => acc.concat(value), []);
        return {
            frozenVideoDuration: reducedDuration,
            videoFreezeCount: reducedDuration.length,
        };
    }
    get analyzersList() {
        return Array.from(this.streamsMap.values());
    }
    get activeProvider() {
        return this.VideoProviderFactory.activeProvider;
    }
    addStream(stream) {
        if (!stream)
            return;
        this.streamsMap.set(stream.id, new VideoFreezeAnalyzer(stream));
    }
}
export default angular
    .module(`doxy.providers.video.common.services.${AngularServices.VideoFreezeDetector}`, [])
    .service(AngularServices.VideoFreezeDetector, VideoFreezeDetector).name;
